























import { Component, Mixins } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class UploadView extends Mixins() {
  headers = [
    { text: '', value: 'name' },
    { text: 'Count', value: 'count' },
    { text: 'Info', value: 'list' },
  ]

  dialogInfoIsOpen = false;
  detailItem: any = null;

  openListDialog(item: any) {
      this.detailItem = item;
      this.dialogInfoIsOpen = true;
  }
}
